import { useLocationCode } from "~/shared/contexts/LocationCodeContext";
import { useDeliveryWindows } from "~/shared/contexts/DeliveryWindowsContext";
import { InlineSelect } from "~/shared/components/InlineSelect";

export function LocationSelector() {
    const { jobLocations } = useDeliveryWindows();
    const { selectedLocationCode, setSelectedLocationCode } = useLocationCode();

    if (!jobLocations.length) return null;

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <label htmlFor="location-select" style={{ fontSize: 14, fontWeight: 500, color: 'var(--text-muted)' }}>
                Location:
            </label>
            <div style={{ minWidth: 140 }}>
                <InlineSelect
                    value={selectedLocationCode ?? ""}
                    onChange={setSelectedLocationCode}
                    size="sm"
                    options={[
                        { value: "", label: "All Locations" },
                        ...jobLocations.map((code) => ({ value: code, label: code })),
                    ]}
                />
            </div>
        </div>
    );
}
